<template>
  <!-- 柱状图2 -->
  <div :id="barAndLineChartInfo.nodeId"></div>
</template>

<script>
export default {
  name: "BarAndLineChart",
  props:["barAndLineChartInfo"],
  data(){
    return {
      // barAndLineChartInfo:{
      //     nodeId:'detailedData',//节点
      //     data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],//数据
      //     data2: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],//数据
      //     xAxisData:['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      //     min:0, //y轴的最小值
      //     max:180, //y轴最大值 
      //     interval:30, //值之间的间隔
     //      yAxisName: '分数',
      // }
    }
  },
  computed:{
    
  },
  methods:{
    barAndLineChart(barAndLineChartInfo){
      // barAndLineChartInfo.data.reverse()
      // barAndLineChartInfo.xAxisData.reverse()
      if(!barAndLineChartInfo.formatter){
        if(barAndLineChartInfo.unit==='%'){
          barAndLineChartInfo.formatter = function (params){
            let vals=params[0].data+barAndLineChartInfo.unit
            return '<div>'+params[0].name+'</div><div>'+ params[0].seriesName+' : '+ vals+'</div>'
          }
        }else{
          barAndLineChartInfo.formatter = function (params) {
            let vals=params[0].data
            if(vals>=10000){
              vals=(vals/10000).toFixed(2)+'w'
            }
            return '<div>'+params[0].name+'</div><div>'+ params[0].seriesName+' : '+ vals+'</div>'
          }
        }
      }
      
      this.$echarts.dispose(document.getElementById(barAndLineChartInfo.nodeId));
      var myChart = this.$echarts.init(document.getElementById(barAndLineChartInfo.nodeId));
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          confine: true,//浮窗不超出屏幕范围
          textStyle: {
            fontSize: 12,
            color: '#333'
          },
          backgroundColor: '#fff',
          borderRadius: 4,  
          axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            type : 'line',         // 默认为直线，可选为：'line' | 'shadow'
            lineStyle : {          // 直线指示器样式设置
                color: '#333',
                width: 0.2,
                type: 'solid'
            },
            z: 2,//竖线在圆圈后面
          },
          extraCssText:'box-shadow:0 0 18px rgba(0,0,0,0.2)',//提示框阴影
          formatter:barAndLineChartInfo.formatter,
          // formatter:function(params){
          //   return params
          //   // return (  '<div style = "text-align:center">' +  '功率 ' + ':' + 1 + '<br/>' + '转速' + ':' + 1 + '<br/>' + '时间' + ':' + 1 + '(h)')  + '</div>';
          //   return (  '<div style="width: 320px;height: 128px;padding: 17px;box-sizing: border-box;"><div style="float: left;width: 94px;height: 94px;margin-right: 13px;border-radius: 4px;overflow: hidden;"><img src="'+
          //   'https://img11.18183.com/ku18183/image/2020/04/15/351ac9d657d10ae805fb5e7e2923fd0a.jpg'+'" alt="" style="width:100%;height:100%;"></div><div style="font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;"><p style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">'+
          //   "{c1}"+'</p><span style="margin-right: 13px;">'+
          //   '123w'+'</span><b>'+'17.37w'+'</b><p>'+'2021-07-13 09:00'+'</p></div></div>');
          // }
        },
        grid: {
              x:50,
              y:40,
              x2:60,
              y2:36
        },
        // calculable: true,
        xAxis: [{
          type:'category',
          show:barAndLineChartInfo.xShow?false:true,
          // data: ['1月 周一', '2月 周二', '3月 周二', '4月 周二', '5月 周二', '6月 周二', '7月', '8月', '9月', '10月', '11月', '12月']
          // .map(function(str){
          //   return str.replace(' ','\n')
          // }),
          // data: ['1月'+<br/>+'123', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          data: barAndLineChartInfo.xAxisData,
          axisLine:{
              show:true,//去除y轴线
              lineStyle: {
                  color: '#ccc',
                  width: 0.8, //这里是为了突出显示加上的  
              }
          },
          axisLabel: {
              textStyle: {
                  color:  '#999' , //坐标字值得具体的颜色
              }
          },
          axisTick:{
              show:false//去除y轴刻度
          },
        }],
        yAxis:[
          {
            type: 'value',
            scale:true,
            name: barAndLineChartInfo.yAxisName,
            // min:barAndLineChartInfo.min, //y轴的最小值
            // max:barAndLineChartInfo.max, //y轴最大值 
            // interval:barAndLineChartInfo.interval, //值之间的间隔
            // gridIndex: 1,
            nameTextStyle:{
              padding:[0,0,10,-40],
              color:"#999",
            },
            splitLine:{
              show: true,
              lineStyle:{
                  type:'dashed',
                  color:"#ddd",
                  width:0.6
              },
            },//去除网格线
            axisLabel:{
              formatter:function (value) {
                var txt=[]
                if(value>=10000){
                  txt.push(value/10000+'w')
                }else{
                  txt.push(value)
                }
                return txt+"%"
              },
              textStyle: {
                color: '#999', //坐标值得具体的颜色
              }
            },
            axisLine:{
                show:false//去除y轴线
            },
            axisTick:{
                show:false//去除y轴刻度
            }
          },
          {
            show: false,
            type: 'value',
          }
        ],
        series: [
            {
                yAxisIndex:0,
                name: '城市占比',
                type: 'bar',
                data:barAndLineChartInfo.data,
                // data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
                barWidth:16,//宽度
                silent: true,
                itemStyle: {
                  //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                  normal: {
                    //柱形图圆角，初始化效果
                    barBorderRadius:[15, 15, 0, 0],
                    show:true,
                    color:new this.$echarts.graphic.LinearGradient(
                        1, 0, 0, 1,
                        [
                            {offset: 0, color: '#4faefc'},
                            {offset: 1, color: '#187bfc'}
                        ]
                    ),
                    label: {
                      show: true,  //开启显示
                      position: 'top',  //在上方显示
                      textStyle: {  //数值样式
                        color: '#999',
                        fontSize: 12
                      },
                      formatter:function (value) {
                        var txt=value.value
                        if(txt>=10000){
                          txt=(txt/10000).toFixed(2)+'w'
                        }
                        return txt
                      },
                    }
                  },
                },
                emphasis:{
                    itemStyle:{
                        color:"#3092fc"//高亮
                    }
                },
                markLine: barAndLineChartInfo.hideMarkLine ? null:{
                    symbol:'none',
                    label:{
                      formatter:function (value) {
                        var txt=value.value
                        if(txt>=10000){
                          txt=(txt/10000).toFixed(2)+'w'
                        }
                        return txt
                      },
                      color:'#3092fc'
                    },
                    data: [
                        {type: 'average', name: '平均值'}
                    ]
                }
            },
            {
              yAxisIndex:1,
              name: 'TGI指数',
              type: 'line',
              data:barAndLineChartInfo.data2,
              itemStyle: { //折线样式 
                hoverAnimation: false,
                symbolSize: 8,
                showSymbol: false,
                color: '#13deb9',
              }
            }
        ],
        axisPointer:[{
            shadowStyle:{
                color:"rgba(255,255,255,0)"//阴影
            }
        }]
      })
    }
    
  },
  components:{
   
  },
  watch:{
    
  },
  mounted() {
    this.barAndLineChart(this.barAndLineChartInfo)
  }
}
</script>

<style scoped>
  

</style>